import { render, staticRenderFns } from "./QuotaRun.vue?vue&type=template&id=1bc84af8&scoped=true&"
import script from "./QuotaRun.vue?vue&type=script&lang=js&"
export * from "./QuotaRun.vue?vue&type=script&lang=js&"
import style0 from "./QuotaRun.vue?vue&type=style&index=0&id=1bc84af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc84af8",
  null
  
)

export default component.exports